import { render, staticRenderFns } from "./KoReport.vue?vue&type=template&id=2a76a751&"
import script from "./KoReport.vue?vue&type=script&lang=js&"
export * from "./KoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports